export default __webpack_public_path__ + "static/media/popular-place-london.9048823d.jpg";